import axios from "axios";
import { AUTH_API, AUTH_KEY } from "./credentials";

export const axiosGate2ALL = axios.create({
  baseURL: "https://api.gate2all.com.br/v1",
  headers: {
    "Content-type": "application/json",
    'Access-Control-Allow-Origin' : '*',
    'Access-Control-Allow-Methods':'GET,PUT,POST,DELETE,PATCH,OPTIONS',
    'authenticationApi' : AUTH_API,
    'authenticationKey' : AUTH_KEY
  }
});

export const axiosSEC = axios.create({
  baseURL: 'https://secpay.app.br/api-local/',
  headers: {
    'Content-type': 'application/json',
    'Access-Control-Allow-Origin' : '*',
    'Access-Control-Allow-Methods':'GET,PUT,POST,DELETE,PATCH,OPTIONS'
  }
});
